(window as any).FontAwesomeConfig = { autoReplaceSvg: 'nest' };
export {};
